import React from 'react';
import { Helmet } from 'react-helmet-async';

const SuccessSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "ConfirmAction",
    "name": "Booking Confirmation",
    "description": "Airport parking booking successfully confirmed",
    "actionStatus": "http://schema.org/CompletedActionStatus",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": "https://airportparkingdeals.co.uk/success"
    },
    "object": {
      "@type": "Reservation",
      "name": "Airport Parking Reservation",
      "reservationFor": {
        "@type": "ParkingFacility",
        "name": "Airport Parking"
      }
    }
  };

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Booking Confirmed | Airport Parking Deals",
    "description": "Your airport parking booking is confirmed! Check your email for booking details and parking instructions.",
    "url": "https://airportparkingdeals.co.uk/success",
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://airportparkingdeals.co.uk"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Search",
          "item": "https://airportparkingdeals.co.uk/search"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Booking",
          "item": "https://airportparkingdeals.co.uk/booking"
        },
        {
          "@type": "ListItem",
          "position": 4,
          "name": "Payment",
          "item": "https://airportparkingdeals.co.uk/payment"
        },
        {
          "@type": "ListItem",
          "position": 5,
          "name": "Confirmation",
          "item": "https://airportparkingdeals.co.uk/success"
        }
      ]
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify([schema, webPageSchema])}
      </script>
    </Helmet>
  );
};

export default SuccessSchema;

